import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=57251136&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57251136')) {
      api.createRecord('57251136', component.options)
    } else {
      api.reload('57251136', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=57251136&", function () {
      api.rerender('57251136', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-28bm7pFb5xAJg/JS/comp/ImgFallback.vue"
export default component.exports